// hooks/useDebounceClick.ts
import { useRef, useCallback } from 'react';

/**
 * Prevents a function from being called multiple times within a delay window.
 * @param delay Time in milliseconds to block subsequent calls (default: 1000ms)
 * @returns A debounced version of the callback executor
 */
export function useDebounce(delay: number = 1000): (fn: () => void) => void {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isBlockedRef = useRef<boolean>(false);

  return useCallback((fn: () => void): void => {
    if (isBlockedRef.current) return;

    isBlockedRef.current = true;
    fn();

    timeoutRef.current = setTimeout(() => {
      isBlockedRef.current = false;
    }, delay);
  }, [delay]);
}
